import React from 'react';
import PanelHeader from '@app/Areas/Optimus/Components/Shared/PanelHeader';
import { createStyles, Grid, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import { GroupEditorModel } from './GroupEditorModel';

export interface GroupEditorProps {
    group: GroupEditorModel;
    handleGroupChange: (event: any) => void;
    title?: string;
    // handleReset: (event: any) => void;
    isSaving: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
        marginBottom: 20
    },
    form: {
        padding: '0.75rem'
    }
  }),
);

function GroupEditor({
    title,
    isSaving,
    group,
    handleGroupChange
}: GroupEditorProps) {
    const classes = useStyles();

    return (
        <form className={classes.form}>
            { isSaving && <Typography variant="h4">Saving Group...</Typography> }
            <PanelHeader headerVariant="h5" header={`Add new Group - ${title}`}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            className={classes.input}
                            fullWidth id="group-name-input"
                            label="Name"
                            name="name"
                            value={group.name}
                            onChange={handleGroupChange}
                        />
                    </Grid>
                </Grid>
            </PanelHeader>
        </form>
    )
}

export default GroupEditor;
